import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { target: String }

  open() {
    const drawer = document.getElementById(this.targetValue)
    if (!drawer) return
    const controller = this.application.getControllerForElementAndIdentifier(drawer, "drawer")
    controller?.open()
  }
}
